module.exports = __webpack_public_path__ + "img/Perspektive 7-31-07.34049082.jpg";